<div class="main-wrapper-section">
    <div class="common-header">
        <h3>Pause</h3>
    </div>
    <div class="card-section">
        <div class="card-panel">
            <form [formGroup]="memPauseForm">
                <div class="field-form-panel">
                    <h4>{{pauseID > 0 || contactId > 0 ? memPause?.contactName : 'Add'}}</h4>
                    <hr />
                    <div class="flex-form contracts-flex-form">
                        <div class="form-group">
                            <label>Pause Type</label>
                            <select class="form-control" formControlName="pauseTypeID">
                                <option value="0">--Select--</option>
                                <option *ngFor="let item of ref_MemPauseType_List" [value]="item.statusID">{{item?.status}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Hardship Reason</label>
                            <select class="form-control" formControlName="hardshipReasonID">
                                <option value="0">--Select--</option>
                                <option *ngFor="let item of ref_MemHardshipReason_List" [value]="item.statusID">{{item?.status}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Indefinite Reason</label>
                            <select class="form-control" formControlName="indefiniteReasonID">
                                <option value="0">--Select--</option>
                                <option *ngFor="let item of ref_MemIndefiniteReason_List" [value]="item.statusID">{{item?.status}}</option>
                            </select>
                        </div>
                        <div class="form-group" *ngIf="pauseID == 0 && contactId == 0">
                            <label>Contact</label>
                            <select class="form-control" formControlName="contactId" (change)="onChangeMemContact()">
                                <option value="0">--Select--</option>
                                <option *ngFor="let item of memContact_dd" [value]="item.id">{{item?.text}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Pause Start Date</label>
                            <mat-form-field>
                                <input matInput #ref [matDatepicker]="pauseStartDate" class="form-control" formControlName="pauseStartDate" id="pauseStartDate">
                                <mat-datepicker-toggle matSuffix [for]="pauseStartDate"></mat-datepicker-toggle>
                                <mat-datepicker #pauseStartDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <label>Pause End Date</label>
                            <mat-form-field>
                                <input matInput #ref [matDatepicker]="pauseEndDate" class="form-control" formControlName="pauseEndDate" id="pauseEndDate">
                                <mat-datepicker-toggle matSuffix [for]="pauseEndDate"></mat-datepicker-toggle>
                                <mat-datepicker #pauseEndDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <label>Pause Amount</label>
                            <input class="form-control" type="text" formControlName="pauseAmount" />
                        </div>
                    </div>
                </div>
                <button type="button" class="primary-btn" *ngIf="pauseID == 0 && contactId == 0" (click)="memPause_Create()">Save</button>
                <button type="button" class="primary-btn" *ngIf="pauseID > 0 || contactId > 0" (click)="memPause_Update()">Update</button>
                <button type="button" class="black-btn" *ngIf="pauseID > 0 || contactId > 0" (click)="memPause_Delete()">Delete</button>
            </form>
        </div>
    </div>
</div>

